<template>
  <div class="flex gap-1">
    <Tab
      v-for="(tab, index) in tabs"
      :key="index"
      :tab="tab"
      @select="emit('select', tab)"
    />
  </div>
</template>

<script setup>
import { Tab } from "@/Components/Navigation/Tabs";

const emit = defineEmits(["select"]);

defineProps({
  tabs: {
    type: Array,
    required: true,
  },
});
</script>
